import { apiGet, apiPost } from "../client";

export async function fetchAdminOperationsOverview({ refresh = false } = {}) {
  return apiGet(`/admin/operations/overview${refresh ? "?refresh=1" : ""}`);
}

export async function runAdminOperationalChecks() {
  return apiPost("/admin/operations/run-checks", {});
}
